import { useIntl } from "react-intl";

import { useFeatureIsOn } from "@/app/featureFlags";
import { usePaymentContext } from "@/contexts/PaymentContext";
import { includeBnplFee, calculateMonthlyInstallment } from "@/utils/bnpl-fee";
import { formatCurrency } from "@/utils/currency";

export type Props = {
  totalPrice: number;
};

export function PaymentOptions({ totalPrice }: Props) {
  const intl = useIntl();
  const { maxAvailableInstallments, isEligible } = usePaymentContext();
  const isBnplFeatureEnabled = useFeatureIsOn("bnpl") && Boolean(isEligible);

  const includedBnplFee = includeBnplFee(totalPrice);
  const monthlyPayment = calculateMonthlyInstallment(
    includedBnplFee,
    maxAvailableInstallments,
  );

  return (
    <div className="mb-4 flex h-full flex-col gap-4">
      {isBnplFeatureEnabled && (
        <div className="flex items-center justify-between">
          <span className="text-sm font-semibold text-text-primary">
            {intl.formatMessage({
              defaultMessage: "Pay later price per month",
              description: "payment.payLaterPerMonth",
            })}
          </span>
          <span className="text-md font-semibold">
            {formatCurrency(monthlyPayment)}
          </span>
        </div>
      )}
      <div className="flex items-center justify-between">
        <span className="text-sm font-semibold text-text-primary">
          {intl.formatMessage({
            defaultMessage: "Standard price",
            description: "payment.standard",
          })}
        </span>

        <span className="text-md font-semibold">
          {formatCurrency(totalPrice)}
        </span>
      </div>
    </div>
  );
}
